<script>
export default {
  name: "navigation",
  data: () => ({
    allNavigationItems: [{ icon: "mdi-account-voice", text: "Requirements", link: "/requirements", permissions: "administrator, owner, broker, charterer", key: "requirements" }],
    drawer: false,
    showMobileNavigation: true,
  }),
  methods: {
    capitalize(text) {
      capitalize(text);
    },
    onExpandDrawer() {
      if (this.$vuetify.breakpoint.xs) {
        this.drawer = !this.drawer;
      } else {
        this.drawer = true;
      }
    },
    showNavigation() {
      this.showMobileNavigation = true;
    },
    logout() {
      this.$store.dispatch("logout");
    },
  },
  created: function() {},
  computed: {
    userName() {
      return this.$store.state.user.name;
    },
    userRole() {
      return capitalize(this.$store.state.role);
    },
    showRole() {
      return this.$store.state.role.indexOf("admin") == -1;
    },
    profilePhotoId() {
      return this.$store.state.user.profilePhotoId;
    },
    isAuthorised() {
      return this.$store.state.isAuthorised;
    },
    path() {
      return this.$route.path;
    },
    profilePhotoSource: function() {
      var url = `${process.env.VUE_APP_API_URL}/portal/downloadDocument`;
      return url + "?id=" + this.profilePhotoId;
    },
    noPhotoSource: function() {
      return `/images/seabrokersLogoNoText.png`;
    },
  },
  mounted() {},
};
</script>
<template>
  <div>
    <div>
      <v-container app>
        <v-row>
          <v-icon @click.stop="showNavigation" style="position:absolute;left:15px;top:15px;z-index:2" color="primary">mdi-menu</v-icon>
        </v-row>
      </v-container>
      <v-navigation-drawer app v-model="showMobileNavigation">
        <v-list>
          <v-list-item>
            <v-img width="60%" class="pt-6" contain src="../../assets/images/sea-projects.png"></v-img>
          </v-list-item>
          <v-list-item two-line>
            <v-list-item-content>
              <v-list-item-title>{{ userName }}</v-list-item-title>
              <v-list-item-subtitle @click="logout" class="underline-hover">Log out</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-list-item v-for="(navItem, index) in allNavigationItems" :key="index" :to="navItem.link">
            <v-list-item-title
              ><v-icon class="icon-left">{{ navItem.icon }}</v-icon
              >{{ navItem.text }}</v-list-item-title
            >
          </v-list-item>
        </v-list>
      </v-navigation-drawer>
    </div>
  </div>
</template>
<style>
.v-list a:hover {
  text-decoration: none;
}

.logged-in-details {
  width: 100%;
  text-align: center;
}
.logged-in-details:hover {
  text-decoration: underline;
}
.underline-hover:hover {
  text-decoration: underline;
  cursor: pointer;
}
</style>
